import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Form, Input }           from "semantic-ui-react";
import Building                  from "../../../../domain/fundamentals/address/Building";
import City                      from "../../../../domain/fundamentals/address/City";
import PostalCode                from "../../../../domain/fundamentals/address/PostalCode";
import Prefecture                from "../../../../domain/fundamentals/address/Prefecture";
import Street                    from "../../../../domain/fundamentals/address/Street";
import Email                     from "../../../../domain/fundamentals/email/Email";
import Office                    from "../../../../domain/office/Office";
import OfficeName                from "../../../../domain/office/OfficeName";
import OfficeNameKana            from "../../../../domain/office/OfficeNameKana";
import OfficeRepository          from "../../../../domain/office/OfficeRepository";
import OfficeDataSource          from "../../../../infrastructure/datasource/office/OfficeDataSource";
import AddressFormField          from "../../common/AddressFormField";
import ValidatorMessage          from "../../message/ValidatorMessage";

const OfficeSettingForm: FC = () => {
  const office: Office = useStore().getState().office;
  const repository: OfficeRepository = new OfficeDataSource(useDispatch());

  return (
    <>
      <Form>
        <Form.Field required>
          <label>事業所名</label>
          <Input
            defaultValue={ office.name.value }
            onChange={ (event, data) => repository.setOfficeName(new OfficeName(data.value)) }
          />
          <ValidatorMessage target="name"/>
        </Form.Field>
        <Form.Field required>
          <label>事業所名カナ</label>
          <Input
            defaultValue={ office.nameKana.value }
            onChange={ (event, data) => repository.setOfficeNameKana(new OfficeNameKana(data.value)) }
          />
          <ValidatorMessage target="name_kana"/>
        </Form.Field>
        <Form.Field required>
          <label>事業所Eメールアドレス</label>
          <Input
            defaultValue={ office.email.value }
            onChange={ (event, data) => repository.setOfficeEmail(new Email(data.value)) }
          />
          <ValidatorMessage target="email_address"/>
        </Form.Field>

        <AddressFormField
          address={ office.address }
          setPostalCode={ (postalCode: PostalCode) => repository.setOfficeAddressPostalCode(postalCode) }
          setPrefecture={ (prefecture: Prefecture) => repository.setOfficeAddressPrefecture(prefecture) }
          setCity={ (city: City) => repository.setOfficeAddressCity(city) }
          setStreet={ (street: Street) => repository.setOfficeAddressStreet(street) }
          setBuilding={ (building: Building) => repository.setOfficeAddressBuilding(building) }
        />
      </Form>
    </>
  )
};

export default OfficeSettingForm;